import {
	clampToTodayOrLater,
	toLocalCalendarDate,
} from "@memorang/helpers/date";
import { DateTime } from "luxon";

export const resolveInitialPickerDate = (initialDate?: string): Date => {
	const calendarDate = toLocalCalendarDate(initialDate);
	if (calendarDate) {
		return clampToTodayOrLater(DateTime.fromJSDate(calendarDate));
	}
	return DateTime.local().plus({ months: 1 }).startOf("day").toJSDate();
};
